import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCaretLeft } from "@fortawesome/free-solid-svg-icons"
import AniLink from "gatsby-plugin-transition-link/AniLink"

import Image from "../Common/image"

const ButtonContainer = styled.div`
  position: absolute;
  left: 128px;

  @media (max-width: 1200px) {
      position: static;
      flex: 1;
  }
`;

const ButtonBase = styled.button`
  background-color: #d13639;
  border-radius: 16px;
  width: 350px;
  height: 100px;
  cursor: pointer;
  color: #f6f6f6;
  padding: 8px 16px;
  border: 0;
  transition: 0.25s ease;
  
  &:hover {
    transform: scale(1.1);
  }

  &:focus {
    outline: 0;
    transform: scale(1);
    transition: none;
  }

  @media (max-width: 768px) { 
    width: 300px;
  }

  @media (max-width: 650px) { 
    width: 232px;
  }

  @media (max-width: 500px) { 
    width: 150px;
    height: 56px;
    border-radius: 8px;
  }

  @media (max-width: 320px) {
    width: 134px;
  }
`;

const IconContainer = styled.span`
  display: inline-block;
  vertical-align: middle;
`;

const Divider = styled.span`
    width: 2px;
    height: 70px;
    background-color: #f6f6f6;
    display: inline-block;
    margin: 8px 16px;
    margin-left: 32px;
    vertical-align: middle;

    @media (max-width: 1200px) {
        height: 26px;
    }

    @media (max-width: 500px) {
      margin: 8px;
    }
`;

const Text = styled.div`
  display: inline-block;
  vertical-align: middle;
  text-transform: uppercase;
  width: 170px;
  margin-left: 32px;

  @media (max-width: 1200px) {
    margin-left: 0;
  }

  @media (max-width: 650px) { 
    width: 112px;
    margin-left: 16px;
  }

  @media (max-width: 500px) {
    width: 80px;
    margin-left: 0;
  }

  @media (max-width: 320px) {
    width: 72px;
  }
`;

const RuneterraButton = ({ onClick }) => {
  return (
      <ButtonContainer>
        <AniLink swipe direction="right" to="/lor" duration="0.5" id="lorNavButton">
          <ButtonBase onClick={() => onClick(0)}>
              <IconContainer>
                <FontAwesomeIcon icon={faCaretLeft} size="2x"/>
              </IconContainer>
              <Divider />
              <Text>
                <Image name="runeterraLogo"/>
              </Text>
          </ButtonBase>
        </AniLink>
      </ButtonContainer>
  )
}

RuneterraButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default RuneterraButton;
